import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=79566ec2&scoped=true&"
import script from "./aboutUs.vue?vue&type=script&lang=ts&"
export * from "./aboutUs.vue?vue&type=script&lang=ts&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=79566ec2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79566ec2",
  null
  
)

export default component.exports